import { PABankTemplateMenuUtility } from "./pa-bank-template-menu-utility";
import { PAMenuUtility } from "./pa-menu.utility";

export class PABankTemplateMenuBuilder {

  public static buildBankTemplateMenuDesktop(bankTemplate: string) {
    PABankTemplateMenuUtility.initTmpMapMenuDesktop();
    let menu = PAMenuUtility.buildMenuDesktop();
    let func: Function | undefined = PABankTemplateMenuUtility.tmpMapMenuDesktop.get(bankTemplate);
    if (func) {
      func.call(this, menu);
    }
    return menu;
  }

  public static buildBankTemplateMenuDesktopTop(bankTemplate: string) {
    PABankTemplateMenuUtility.initTmpMapMenuDesktopTop();
    let menu = PAMenuUtility.buildMenuDesktopTop();
    let func: Function | undefined = PABankTemplateMenuUtility.tmpMapMenuDesktopTop.get(bankTemplate);
    if (func) {
      func.call(this, menu);
    }
    return menu;
  }

  public static buildBankTemplateMenuMobileView(bankTemplate: string) {
    PABankTemplateMenuUtility.initTmpMapMenuMobileView();
    let menu = PAMenuUtility.buildMenuMobileView();
    let func: Function | undefined = PABankTemplateMenuUtility.tmpMapMenuMobileView.get(bankTemplate);
    if (func) {
      func.call(this, menu);
    }
    return menu;
  }

  public static buildBankTemplateMenuMobileApp(bankTemplate: string) {
    PABankTemplateMenuUtility.initTmpMapMenuMobileApp();
    let menu = PAMenuUtility.buildMenuMobileApp();
    let func: Function | undefined = PABankTemplateMenuUtility.tmpMapMenuMobileApp.get(bankTemplate);
    if (func) {
      func.call(this, menu);
    }
    return menu;
  }
}